module.exports = __webpack_public_path__ + "img/qanda.4820535c.png";